import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allTechnicians } from 'app/mocks/data/users/technicians'

import { api } from 'app/utils/constants'

import { Technician, TechnicianPayload } from 'app/types/users/technician'

export const updateTechnician = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.technicians.DETAILS}`,
    async ({ params, request }) => {
        const { id } = params
        const payload = await request.json()
        const payloadParsed = TechnicianPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const technicianFound = allTechnicians.find(
            (technician) => technician.id.toString() === id,
        )

        // Not found
        if (!technicianFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Technician>({
            ...payloadParsed.data,
            client: technicianFound.client,
        })
    },
)
